export default [
  'Montserrat',
  'Helvetica',
  'Arial',
  'Arial Black',
  'Trebuchet MS',
  'Bookman',
  'Georgia',
  'Garamond',
  'Impact',
  'Tahoma',
  'Palatino',
  'Courier',
  'Times New Roman',
  'Verdana',
  'Montserrat',
  'Roboto',
  'Roboto Slab',
  'Nanum Gothic',
  'Encode Sans Condensed',
  'Oswald',
  'Fira Sans',
  'Libre Franklin',
  'Tajawal',
  'Open Sans',
  'AvenirLTStd'
]



// WEBPACK FOOTER //
// ./src/utils/fonts.js